<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          WebページのHTMLのサイズに問題はありませんでした。
        </p>
        <p v-else>WebページのHTMLのサイズに問題がありました。</p>
      </div>
    </li>
    <li v-if="htmlSizeByte || htmlSizeByte === 0" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>サイズ: {{ (htmlSizeByte / 1000) | separateNumber }}KB</p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          HTMLのサイズを33KB以下に修正しましょう。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    htmlSizeByte() {
      const size = this.detail.size;
      return size.compressedHtml ? size.compressedHtml : size.noCompressedHtml;
    }
  }
};
</script>
